export const AVAILABLE_REGIONS = {
  NETHERLANDS: 'NL',
  WORLDWIDE: 'WW'
};
